import React from "react";
import "../components.css";


export default function Display ({ label = "Label", width = "25vw", height = "25vh", text = "Text", backgroundColor = "red", hideVar = false }) {
    const style = {
        width: width,
        height: height,
    }

    var displayText = hideVar ? <p></p> : <p>{text}</p>;
    
    return (
        <div className="tile" style={style}>
            <div className="tileDisplay" style={Object.assign({}, {backgroundColor: backgroundColor})}>
                <h1>{label}</h1>
                {displayText}
            </div>
        </div>
    )
}